<label *ngIf="showLabel" [class]="labelClass">{{ 'DropDowns.Label.Plant' | translate }}</label>

<p-multiSelect
  *ngIf="isMultiple"
  appendTo="body"
  [(ngModel)]="value"
  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
  [filter]="showFilter"
  [options]="plantOptions"
  (ngModelChange)="onValueChange($event)"
  [virtualScroll]="virtualScroll"
  [itemSize]="40"
  [showToggleAll]="false">

  <ng-template pTemplate="selectedItems" let-value>
    <ng-container *ngIf="!value || value.length === 0; else showData">
      <span>
        {{ 'Common.Message.ChooseOption' | translate }}
      </span>
    </ng-container>
    <ng-template #showData>
      <span *ngFor="let val of value; first as isFirst">
        <ng-container *ngIf="!isFirst">, </ng-container>
        {{ val | optionsMapping : plantOptions }}
      </span>
    </ng-template>
  </ng-template>
</p-multiSelect>

<p-dropdown
  *ngIf="isSingle"
  appendTo="body"
  [(ngModel)]="value"
  [filter]="showFilter"
  placeholder="{{ 'Common.DropDown.Select' | translate}}"
  [options]="plantOptions"
  [showClear]="showClear"
  [itemSize]="40"
  [virtualScroll]="virtualScroll"
  (ngModelChange)="onValueChange($event)">
</p-dropdown>
